module.exports = __webpack_public_path__ + "img/img17.a0eb3d25.svg";